<template>
    <div class="tiles grid grid__base">
        <div class="tiles--container grid--container">
            <div class="tiles--row grid--row">
                <div class="tiles--item grid--col" v-for="(tile, index) in flattenedTiles" :key="index">
                    <h1 class="tiles--title u-reset" v-if="tile.meta">{{ tile.meta.title }}</h1>
                    <tile v-bind="tile"/>
                </div>
            </div>
            <div class="tiles--links-list" v-if="linkList.length">
                <link-list :links="linkList"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Tile from 'framework/components/tile/tile';
    import LinkList from 'framework/components/link-list/link-list';

    export default {
        components: { LinkList, Tile },
        props: {
            /** @type {ITilesContainer[]} */
            groups: {
                type: Array,
                required: true,
            },
        },
        computed: {
            /**
             * Due to a weird layout scaffold we need to flatten the groups received
             * @see zpl://screen?sid=5b3c6adc7d68e72b46512ef1&pid=5b3b604d1d253d11316cebf2
             * @type {ITile[]} the extracted tiles from the groups
             */
            flattenedTiles: {
                get() {
                    return this.groups.reduce((acc, group) => {
                        const [firstTile, ...tail] = group.tiles;

                        return [
                            ...acc, {
                                // add some meta title property to the first slide
                                meta: {
                                    title: group.title,
                                },
                                ...firstTile,
                            },
                            ...tail,
                        ];
                    }, []);
                },
            },
            /** @type {ILink[]} */
            linkList: {
                get() {
                    return this.groups.map(group => group.link).filter(Boolean);
                },
            },
        },
    };
</script>
